var calculatePage = function calculatePage(_ref) {
  var offset = _ref.offset,
      perPage = _ref.perPage;
  if (perPage === 0) return 0;
  return Math.ceil(offset / perPage);
};

export default calculatePage;
//# sourceMappingURL=calculatePage.esm.js.map
